"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.report = void 0;
const color_1 = require("../utils/color");
const in_browser_p_1 = require("../utils/in-browser-p");
const interval_1 = require("../utils/interval");
function report(span, context) {
    let s = repr_in_context(span, context);
    s = decorate_line_number(s);
    s = line_span_focus(to_line_span_in_context(span, context), s, 3);
    return s;
}
exports.report = report;
const color_mode = (0, in_browser_p_1.in_browser_p)() ? "html" : "escape-code";
function repr_in_context(span, context, opts = {
    mode: color_mode,
}) {
    let s = "";
    for (let i = 0; i < context.length; i++) {
        if (span.lo <= i && i < span.hi) {
            s += (0, color_1.color)(context.charAt(i), Object.assign(Object.assign({}, opts), { background: "red" }));
        }
        else {
            s += context.charAt(i);
        }
    }
    // NOTE END_OF_FILE
    if (span.lo === context.length && span.hi === context.length) {
        s += (0, color_1.color)(" ", Object.assign(Object.assign({}, opts), { background: "red" }));
    }
    return s;
}
function decorate_line_number(text) {
    let lines = text.split("\n");
    let max = lines.length + 1;
    let width = max.toString().length;
    let decorated = "";
    for (const [i, line] of lines.entries()) {
        let line_number = i + 1; // NOTE index from 1 instead of 0
        let line_number_string = line_number.toString();
        line_number_string =
            " ".repeat(width - line_number_string.length) + line_number_string;
        decorated += " ";
        decorated += line_number_string;
        decorated += " |";
        decorated += line;
        decorated += "\n";
    }
    return decorated;
}
function to_line_span_in_context(span, context) {
    let line_indexes = new Set();
    let cursor = 0;
    let lines = context.split("\n");
    for (let [i, line] of lines.entries()) {
        if ((0, interval_1.interval_overlap_p)(span.lo, span.hi, cursor, cursor + line.length + 1)) {
            line_indexes.add(i);
        }
        cursor += line.length + 1;
    }
    const lo = Math.min(...line_indexes);
    const hi = Math.max(...line_indexes);
    return { lo, hi };
}
function line_span_focus(span, context, margin) {
    let lines = context.split("\n");
    return lines.slice(Math.max(0, span.lo - margin), span.hi + margin).join("\n");
}
//# sourceMappingURL=span-report.js.map